import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';

export class DownloaderService {
  constructor() {}

  async downloadXML(xml_text, namefile) {
    const blob = new Blob([xml_text], {
      type: 'application/xml',
    });
    saveAs(blob, namefile);
  }

  async toExcel(
    json: any[],
    filename,
    wscols: number[] = [],
    header = null,
    sheetname = 'data',
    column_to_string: string[] = []
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json, {
        header: header,
      });
      if (wscols) {
        worksheet['!cols'] = wscols.map((w: number) => {
          let wc: XLSX.ColInfo = {};
          wc.wch = w;
          return wc;
        });
      }

      let sheets = {};
      sheets[sheetname] = worksheet;

      const workbook: XLSX.WorkBook = {
        Sheets: sheets,
        SheetNames: [sheetname],
      };

      column_to_string.map((column) => {
        for (let i = 1; i <= json.length + 1; i++)
          workbook.Sheets[sheetname][`${column}${i}`].z = '@';
      });

      'abcdefghijklmnopqrstuvwxyz'
        .toUpperCase()
        .split('')
        .map((column) => {
          for (let i = 1; i <= json.length + 1; i++) {
            try {
              workbook.Sheets[sheetname][`${column}${i}`].s = {
                alignment: {
                  wrapText: '1', // any truthy value here
                },
              };
            } catch (error) {}
          }
        });

      const excelBuffer: any = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'buffer',
      });
      XLSX.writeFile(workbook, filename + new Date().getTime() + '.xlsx');
      resolve('');
    });
  }

  async downloadCSV(text: string, namefile: string) {
    const blob = new Blob([text], {
      type: 'application/csv',
    });
    saveAs(blob, namefile);
  }

  public async bufferDownload(
    data: ArrayBuffer,
    title: string,
    mime: string = 'application/zip'
  ) {
    const blob = new Blob([data], {
      type: mime,
    });
    saveAs(blob, `${title}`);
  }
}
